import { useMemo } from 'react'

import { Tooltip } from '@blade/ui-kit'
import { NumericFormat } from '@root/shared/core/format'
import { useTranslation } from '@root/shared/localization'
import {
  MakerDolphinIcon,
  MakerFishIcon,
  MakerShrimpIcon,
  MakerWhaleIcon,
} from '@root/shared/ui-kit'

import { Maker } from '../model'

import type { ClassNameProps } from '@root/shared/react'
import type { IconProps } from '@root/shared/ui-kit'
import type BigNumber from 'bignumber.js'

type MakerIconProps = {
  size?: number
  volume: BigNumber
} & ClassNameProps

export const MakerIcon: React.FC<MakerIconProps> = ({
  className,
  volume,
  size = 14,
}) => {
  const { t } = useTranslation()
  const volumeType = useMemo(() => Maker.makerSize(volume), [volume])
  const Icon = ICON_MAP[volumeType]

  const volumeFormatted = t('maker.volume-tooltip', {
    amount: NumericFormat.formatPreset(
      volume.toString(),
      'currency-amount-short',
      {
        currency: '$',
      },
    ),
  })

  return (
    <Tooltip content={volumeFormatted}>
      <Icon size={size} className={className} />
    </Tooltip>
  )
}

const ICON_MAP: Record<Maker.MakerSize, React.FC<IconProps>> = {
  whale: MakerWhaleIcon,
  dolphin: MakerDolphinIcon,
  shrimp: MakerShrimpIcon,
  fish: MakerFishIcon,
}
